import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { numberFormatter, paymentMethodEnum } from "../../helper/helpers";
import { useMutation } from "@tanstack/react-query";
import { initiatePaymentApi } from "../../services/products";
// import { getLoggedinUser } from "../lib/axios-client";
import { toast } from "sonner";
import { AlertErrorComponent, AlertSuccessComponent } from "./AlertComponent";
import { useDispatch } from "react-redux";
import { clearLocalCart } from "../../Features/Cart/cartSlice";

const Checkout = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  // const [errorArray, setErrorArray] = useState([]);

  // let { user = {} } = getLoggedinUser();

  let { state: currentOrderState = {} } = location;

  let { orders } = currentOrderState ?? [];
  let items = orders[0]?.items ?? [];

  const { mutate: CheckoutBasketPayment, isPending } = useMutation({
    mutationFn: () => initiatePaymentApi(orders[0]?.orderId),
    onSuccess: (data) => {
      setSuccessMsg(data?.message);
      setErrorMsg("");
      toast.success(data?.message);
      dispatch(clearLocalCart());
    },
    onError: (err) => {
      setErrorMsg(err);
      toast.error(err || "Unable to initiate payment!");
    },
    onSettled: () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // for smooth scrolling
      });
    },
  });

  const handlePayment = () => {
    setSuccessMsg("");
    CheckoutBasketPayment();
  };

  if (
    (!!currentOrderState && !Object.keys(currentOrderState).length) ||
    !currentOrderState
  ) {
    return <Navigate to={"/checkout"} replace state={null} />;
  }

  return (
    <section className="checkout py-30 bg-grey-50">
      <div className="container container-lg">
        {errorMsg && <AlertErrorComponent errorMsg={errorMsg} />}
        {successMsg && <AlertSuccessComponent message={successMsg} />}

        <div className="row">
          <div className="col-xl-8 mx-auto">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="bg-color-three rounded-8 p-24 text-center mb-24">
                  <span className="text-gray-900 text-xl fw-semibold">
                    Order Received
                  </span>
                </div>
                <p className="text-dark">
                  Thank you. Your Order has been received.
                </p>

                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column flex-lg-row justify-content-between">
                      <p className="d-flex flex-column flex-lg-row gap-5">
                        <span>Checkout ID: </span>
                        <span className="fw-semibold text-sm">
                          {orders[0]?.checkoutId}
                        </span>
                      </p>
                      <p className="d-flex flex-column flex-lg-row gap-5">
                        <span>Date: </span>
                        <span className="fw-semibold text-sm">
                          {new Intl.DateTimeFormat("en-US", {
                            dateStyle: "full",
                            timeStyle: "short",
                            // timeZone: "America/New_York",
                          }).format(new Date(orders[0]?.createdAt))}
                        </span>
                      </p>
                    </div>
                    <p className="d-flex gap-5">
                      <span>Items: </span>
                      <span className="fw-semibold text-sm">
                        {items?.length ?? 0}
                      </span>
                    </p>
                    <p className="d-flex gap-5">
                      <span>Payment Method: </span>
                      <span className="fw-semibold text-sm">
                        {paymentMethodEnum[currentOrderState?.paymentMethod]}
                      </span>
                    </p>
                    {/* <div className="row">
                      <div className="col-12 col-sm-4">
                        <div className="mb-5">
                          <p className="d-flex gap-5">
                            <span>
                              Checkout ID:
                              <span className="fw-bold">
                                {orders[0]?.checkoutId}
                              </span>
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="d-flex gap-5">
                            <span>SUB-TOTAL:</span>
                            <span className="fw-bold">
                              {numberFormatter.format(
                                Number(orders[0]?.subTotal),
                              )}
                            </span>
                          </p>
                        </div>
                        <div className="my-5">
                          <p className="d-flex gap-5">
                            <span>VAT:</span>
                            <span className="fw-bold">
                              {numberFormatter.format(
                                Number(orders[0]?.vatAmount),
                              )}
                            </span>
                          </p>
                        </div>
                        <div className="my-5">
                          <p className="d-flex gap-5">
                            <span>Delivery Fee:</span>
                            <span className="fw-bold">
                              {numberFormatter.format(
                                Number(orders[0]?.deliveryFee),
                              )}
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="d-flex gap-5">
                            <span>TOTAL:</span>
                            <span className="fw-bold">
                              {numberFormatter.format(
                                Number(orders[0]?.totalAmount),
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div>
                          <p className="d-flex gap-5">
                            <span>Items:</span>
                            <span className="fw-bold">
                              {currentOrderState?.items?.length ?? 0}
                            </span>
                          </p>
                        </div>
                        <div className="my-5">
                          <p className="d-flex gap-5">
                            <span>Date:</span>
                            <span className="fw-bold">
                              {new Intl.DateTimeFormat("en-US", {
                                dateStyle: "full",
                                timeStyle: "short",
                                // timeZone: "America/New_York",
                              }).format(new Date(orders[0]?.createdAt))}
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="d-flex gap-5">
                            <span>Payment Method:</span>
                            <span className="fw-bold">
                              {
                                paymentMethodEnum[
                                  currentOrderState?.paymentMethod
                                ]
                              }
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="mb-5">
                          <p className="d-flex gap-5">
                            <span>Email:</span>
                            <span className="fw-bold">_</span>
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="oder-details my-20">
                  <h6>Order Details</h6>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <p className="m-0 d-flex justify-content-between fw-semibold fs-5">
                        <span>Product</span>
                        <span>Total</span>
                      </p>
                    </li>
                    {items?.map((product) => (
                      <li
                        className="list-group-item d-flex justify-content-between"
                        key={product?.productId}
                      >
                        <span>
                          {product?.productName}{" "}
                          <em>(X {product?.quantity})</em>{" "}
                        </span>
                        <span>
                          {numberFormatter.format(Number(product?.unitPrice))}{" "}
                          <em>(ex. tax)</em>
                        </span>
                      </li>
                    ))}
                    <li className="list-group-item d-flex justify-content-between mt-20">
                      <span className="fw-semibold">Subtotal:</span>
                      <span className="fw-semibold">
                        {numberFormatter.format(Number(orders[0]?.subTotal))}{" "}
                        <em>(ex. tax)</em>
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="fw-semibold">Payment Method:</span>
                      <span className="fw-semibold">
                        {paymentMethodEnum[currentOrderState?.paymentMethod]}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="fw-semibold">Shipping (inc. VAT):</span>
                      <span className="fw-semibold">
                        {numberFormatter.format(Number(orders[0]?.deliveryFee))}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="fw-semibold">Total:</span>
                      <span className="fw-semibold">
                        {numberFormatter.format(Number(orders[0]?.totalAmount))}
                      </span>
                    </li>
                  </ul>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      type="button"
                      className="btn btn-sm btn-main mt-40 w-25 rounded-8 me-md-2"
                      disabled={isPending}
                      onClick={handlePayment}
                    >
                      {isPending && (
                        <div
                          className="spinner-border spinner-border-sm me-5"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <img
                        src="/assets/images/icon/mpesa-white.png"
                        alt="mpesa"
                        width={100}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
